import { getAppStore } from '../../../../../@data';
import { getProfileStore } from './store';

export function getPublisherProfileRawData() {
  return getAppStore().publisher;
}

export function getPublisherProfileActiveData() {
  return getProfileStore().active;
}

export function getProfileErrors() {
  return getProfileStore().errors;
}

export function getPrimaryUserRawData() {
  return getProfileStore().raw.primaryUser;
}

export function getPrimaryUserFullName() {
  const { name } = getPrimaryUserRawData() || {};
  if (!name) {
    return '';
  }

  return `${name?.firstName} ${name?.lastName}`;
}

export function getPrimaryUserActiveData() {
  return getPublisherProfileActiveData().user;
}

export function getPublisherActiveData() {
  return getPublisherProfileActiveData().publisher;
}

export function isPrimaryUserDataPresent() {
  return !!getPrimaryUserRawData();
}

export function getProfileActiveData() {
  return getProfileStore().active;
}
